module.exports = __webpack_public_path__ + "media/images/athletes/3466-29a202a4c4f458aab7b9114e63ca1631.png";